/**
 * Dizionario italiano — lingua primaria (RNF-30). Tutte le stringhe
 * dell'interfaccia stanno qui (RNF-31): il dizionario inglese è tipizzato su
 * questo, quindi una chiave mancante è un errore di compilazione.
 */
export const it = {
  app: {
    nome: 'Ema Comfort',
    poweredBy: 'Piattaforma Ema Comfort',
    versione: 'Versione',
    caricamento: 'Caricamento dell’impianto…',
  },
  nav: {
    pannello: 'Pannello',
    zone: 'Zone',
    programmazione: 'Programma',
    storico: 'Storico',
    impostazioni: 'Impostazioni',
    notifiche: 'Notifiche',
    sanitario: 'Acqua calda',
    ventilazione: 'Ventilazione',
    tecnico: 'Area tecnica',
    principale: 'Navigazione principale',
  },
  stato: {
    sistema: 'Stato sistema',
    attivo: 'Attivo',
    spento: 'Spento',
    connesso: 'Connesso',
    lan: 'LAN',
    cloud: 'Cloud',
    degradato: 'Parziale',
    irraggiungibile: 'Centralina irraggiungibile',
    datiObsoleti: 'Dati non aggiornati',
    ultimaLettura: 'Ultima lettura valida: {{ora}}',
    nessunaLettura: 'Nessuna lettura ricevuta',
    nonDisponibile: 'Non disponibile',
    sondaScollegata: 'Sonda scollegata',
    aggiornatoOra: 'Aggiornato ora',
    aggiornatoAlle: 'Aggiornato alle {{ora}}',
    ultimoDato: 'Ultimo dato: {{quando}}',
    solaLettura: 'Sola lettura',
    sorgenteCaduta: 'Sorgente non raggiungibile',
    bannerIrraggiungibile: 'La centralina non risponde. I valori mostrati non sono attuali; i comandi non vengono inviati.',
    bannerSolaLettura: 'Modalità sola lettura',
  },
  modalita: {
    titolo: 'Modalità di funzionamento',
    RISCALDAMENTO: 'Riscaldamento',
    RAFFRESCAMENTO: 'Raffrescamento',
    AUTOMATICO: 'Automatico',
    SPENTO: 'Spento',
    attuale: 'Modalità attuale: {{modalita}}',
  },
  zone: {
    titolo: 'Zone',
    principali: 'Impostazioni principali',
    individuali: 'Temperatura zone individuali',
    attiva: 'Attiva',
    spenta: 'Spenta',
    tempDesiderata: 'Temp. desiderata',
    tempAttuale: 'Attuale',
    accendi: 'Accendi {{zona}}',
    spegni: 'Spegni {{zona}}',
    globale: 'Temperatura globale',
    globaleNota: 'Si applica alle zone non impostate singolarmente.',
    piu: 'Aumenta {{zona}} di mezzo grado',
    meno: 'Diminuisci {{zona}} di mezzo grado',
    inDomanda: 'In richiesta',
    aRegime: 'A regime',
    limite: 'Limite {{min}}–{{max}} impostato da {{chi}}',
    fuoriLimite: 'Non inviato: il limite {{min}}–{{max}} è stato impostato da {{chi}}.',
    sovrascritta: 'Impostata singolarmente',
    nessuna: 'Nessuna zona configurata: la centralina non ha dichiarato sonde ambiente.',
    carico: { ELETTROVALVOLA: 'Elettrovalvola', RELE_ON_OFF: 'Relè on/off', VENTILCONVETTORE: 'Ventilconvettore' },
  },
  comando: {
    inInvio: 'In invio…',
    accettato: 'Accettato',
    applicato: 'Applicato',
    fallito: 'Non applicato',
    motivo: {
      centralina_irraggiungibile: 'La centralina non ha risposto.',
      fuori_limiti: 'Valore fuori dai limiti consentiti.',
      sorgente_non_comandabile: 'Questa sorgente è in sola lettura.',
      zona_inesistente: 'Zona non trovata.',
      timeout: 'Nessuna conferma entro il tempo previsto.',
      rifiutato: 'Comando rifiutato dalla centralina.',
    },
  },
  pannello: {
    titolo: 'Pannello',
    ambiente: 'Ambiente',
    centraleTermica: 'Centrale termica',
    mandata: 'Mandata impianto',
    ritorno: 'Ritorno impianto',
    deltaT: 'Delta T',
    accumulo: 'Accumulo inerziale',
    solaLettura: 'Impianto in sola lettura: questa sorgente pubblica i dati ma non accetta comandi.',
    centraleSenzaSonde: 'Questa sorgente non pubblica le temperature di centrale termica: mandata, ritorno e accumulo non sono misurati.',
    accumuloSenzaSonda: 'Nessuna sonda sul puffer',
    accumuloSenzaSondaNota: 'Il valore non viene stimato: la mappa I/O non prevede una sonda sull’accumulo.',
    pufferAlto: 'Alto',
    pufferBasso: 'Basso',
    sanitario: 'Acqua calda',
    esterna: 'Temperatura esterna',
    umidita: 'Umidità',
    luminosita: 'Luminosità',
    circolatore: 'Circolatore',
    acceso: 'Acceso',
    spento: 'Spento',
    generatori: 'Generatori',
    impianto: 'Impianto riscaldamento',
    zoneAttive: '{{n}} di {{tot}} zone in richiesta',
    mediaAmbiente: 'Temperatura ambiente',
    programmazioneOraria: 'Programmazione oraria',
    sorgenti: 'Sorgenti dati',
    energia: {
      titolo: 'Energia',
      produzione: 'Produzione',
      consumo: 'Consumo',
      batteria: 'Batteria',
      rete: 'Rete',
      prelievo: 'Prelievo dalla rete',
      immissione: 'Immissione in rete',
      carica: 'In carica',
      scarica: 'In scarica',
      surplusTitolo: 'Surplus solare',
      surplusDisponibile: 'Surplus di {{kw}} kW disponibile',
      surplusNessuno: 'Nessun surplus in questo momento',
      versoPdc: 'Potrebbe alimentare la pompa di calore e caricare accumulo e acqua calda.',
      comandoNonDisponibile: 'Comando non disponibile: il connettore della pompa di calore è in sola lettura (fase 2).',
      comandoDisponibile: 'Comando disponibile sul generatore.',
      fase2: 'Fase 2',
    },
  },
  generatore: {
    TERMOCAMINO: 'Termocamino',
    STUFA_PELLET: 'Stufa a pellet',
    POMPA_DI_CALORE: 'Pompa di calore',
    CALDAIA_GAS: 'Caldaia a gas',
    priorita: 'Priorità {{n}}',
    mandata: 'Mandata',
    ritorno: 'Ritorno',
    modulante: 'Modulante',
    onOff: 'On/off',
  },
  sanitario: {
    titolo: 'Acqua calda sanitaria',
    accumulo: 'Temperatura accumulo',
    setpoint: 'Temperatura desiderata',
    boost: 'Boost',
    boostAttivo: 'Boost attivo fino alle {{ora}}',
    boostAvvia: 'Avvia boost ({{minuti}} min)',
    boostAnnulla: 'Annulla boost',
    inCarica: 'In carica',
    aRegime: 'A temperatura',
    accesa: 'Accesa',
    spenta: 'Spenta',
    solaLetturaNota: 'Termostati di marca via cloud del produttore: stato in sola lettura.',
    antilegionella: 'Ciclo anti-legionella: {{giorno}} alle {{ora}}:00 a {{temp}}',
    nonPresente: 'Questo impianto non ha un accumulo sanitario collegato.',
    piu: 'Aumenta la temperatura dell’acqua calda',
    meno: 'Diminuisci la temperatura dell’acqua calda',
  },
  vmc: {
    titolo: 'Ventilazione meccanica',
    modalita: { SPENTA: 'Spenta', ACCESA: 'Accesa', AUTO: 'Automatica' },
    umidita: 'Umidità interna',
    soglia: 'In automatico si attiva oltre il {{pct}}% di umidità.',
    attiva: 'In funzione',
    inattiva: 'Ferma',
    nonPresente: 'Questo impianto non ha una ventilazione meccanica collegata.',
  },
  programmazione: {
    titolo: 'Programmazione oraria',
    zona: 'Zona',
    fasce: 'Fasce orarie',
    aggiungi: 'Aggiungi fascia',
    rimuovi: 'Rimuovi',
    da: 'Dalle',
    a: 'Alle',
    setpoint: 'Temperatura',
    attivo: 'Programma attivo',
    disattivo: 'Programma disattivato',
    attivoNota: 'Fuori dalle fasce vale la temperatura impostata nella schermata Zone.',
    profili: 'Profili rapidi',
    profilo: { CASA: 'Casa', FUORI: 'Fuori', NOTTE: 'Notte', VACANZA: 'Vacanza' },
    applicaProfilo: 'Applicare il profilo «{{profilo}}» a tutte le zone ({{temp}})?',
    applicaProfiloNota: 'Le temperature impostate singolarmente verranno sostituite.',
    salva: 'Salva programma',
    salvato: 'Programma salvato',
    nessunaFascia: 'Nessuna fascia in questo giorno.',
    fasceNonValide: 'Le fasce si sovrappongono o hanno orari invertiti.',
    confermaRimozione: 'Rimuovere la fascia {{da}}–{{a}}?',
    inCorso: 'In corso',
    copiaSuFeriali: 'Copia sui giorni feriali',
  },
  storico: {
    titolo: 'Storico',
    giorno: 'Giorno',
    settimana: 'Settimana',
    mese: 'Mese',
    esporta: 'Esporta CSV',
    serie: { zone: 'Zone', esterna: 'Esterna', mandata: 'Mandata', ritorno: 'Ritorno', energia: 'Energia', produzione: 'Produzione', consumo: 'Consumo' },
    nota: 'Serie aggregate dalla centralina alla risoluzione richiesta: {{risoluzione}}.',
    esportaNota: 'Il file riporta intestazione impianto, periodo e grandezze registrate.',
    risoluzione: { '1m': '1 minuto', '15m': '15 minuti', '1h': '1 ora', '1d': '1 giorno' },
    nessunDato: 'Nessun dato nel periodo.',
    temperatura: 'Temperatura',
    potenza: 'Potenza',
  },
  notifiche: {
    titolo: 'Notifiche',
    aperti: 'Aperti',
    tutti: 'Tutti',
    riconosci: 'Riconosci',
    riconosciuto: 'Riconosciuto da {{chi}} alle {{ora}}',
    chiuso: 'Rientrato alle {{ora}}',
    nessuna: 'Nessun allarme. Tutto regolare.',
    severita: { bassa: 'Bassa', media: 'Media', alta: 'Alta', critica: 'Critica' },
    codice: {
      SONDA_GUASTA: 'Sonda guasta',
      SONDA_SCOLLEGATA: 'Sonda scollegata',
      DELTA_T_ANOMALO: 'Delta T anomalo',
      SOVRATEMPERATURA: 'Sovratemperatura',
      GENERATORE_NON_PARTE: 'Mancata accensione generatore',
      CENTRALINA_IRRAGGIUNGIBILE: 'Centralina irraggiungibile',
      SORGENTE_IRRAGGIUNGIBILE: 'Sorgente non raggiungibile',
      PUNTO_DI_RUGIADA: 'Protezione punto di rugiada',
    },
    descrizione: {
      SONDA_GUASTA: 'La sonda {{oggetto}} restituisce valori non plausibili.',
      SONDA_SCOLLEGATA: 'La sonda {{oggetto}} non è collegata: il valore non è disponibile.',
      DELTA_T_ANOMALO: 'Differenza fra mandata e ritorno troppo bassa con circolatore attivo.',
      SOVRATEMPERATURA: 'La mandata ha superato il limite di sicurezza: generatore bloccato.',
      GENERATORE_NON_PARTE: 'Il generatore non si è avviato dopo la richiesta.',
      CENTRALINA_IRRAGGIUNGIBILE: 'Nessuna lettura ricevuta da oltre un minuto.',
      SORGENTE_IRRAGGIUNGIBILE: 'La sorgente «{{oggetto}}» non risponde: i suoi riquadri mostrano l’ultimo dato disponibile.',
      PUNTO_DI_RUGIADA: 'La mandata in raffrescamento è stata alzata per evitare condensa sul pavimento.',
    },
  },
  impostazioni: {
    titolo: 'Impostazioni',
    lingua: 'Lingua',
    unita: 'Unità di temperatura',
    tema: 'Aspetto',
    temaScuro: 'Scuro',
    temaChiaro: 'Chiaro',
    rete: 'Rete',
    reteLan: 'Centralina in LAN · {{host}}',
    reteCloud: 'Collegato tramite cloud',
    reteNota: 'Il pannello parla con la centralina sulla rete di casa: funziona anche senza internet.',
    account: 'Account',
    accountNota: 'Uscire chiude la sessione su tutti i prodotti collegati allo stesso accesso.',
    esci: 'Esci',
    residente: 'Residente',
    areaTecnica: 'Area tecnica',
    areaTecnicaNota: 'Riservata all’installatore: richiede credenziali dedicate.',
    accedi: 'Accedi all’area tecnica',
    informazioni: 'Informazioni',
    impianto: 'Impianto',
    centralina: 'Centralina',
    firmware: 'Firmware',
    installatore: 'Installatore',
    demo: {
      titolo: 'Dimostrazione',
      nota: 'Questi controlli esistono solo nel simulatore: servono a mostrare come l’interfaccia reagisce.',
      marchio: 'Marchio',
      marchioNota: 'Il pannello porta il marchio dell’installatore, non quello della piattaforma.',
      scenari: 'Scenari',
      centralinaIrraggiungibile: 'Centralina irraggiungibile',
      sondaScollegata: 'Sonda {{canale}} scollegata',
      sorgenteGiu: 'Sorgente «{{sorgente}}» non raggiungibile',
      velocita: 'Velocità della simulazione',
      velocitaValore: '{{x}}×',
      impianto: 'Impianto mostrato',
    },
  },
  tecnico: {
    titolo: 'Area tecnica',
    accesso: {
      titolo: 'Accesso area tecnica',
      sottotitolo: 'Credenziali distinte da quelle del residente. La sessione scade dopo 10 minuti di inattività.',
      utente: 'Utente',
      password: 'Password',
      entra: 'Entra',
      errore: 'Credenziali non valide.',
      demoHint: 'Dimostrazione: utente «tecnico», password «emacomfort».',
      sessioneScaduta: 'Sessione scaduta per inattività.',
      esci: 'Esci',
      sessione: '{{operatore}} · scade tra {{minuti}} min',
      tornaAlPannello: 'Torna al pannello',
    },
    nav: {
      parco: 'Parco impianti',
      dashboard: 'Canali',
      io: 'Configurazione I/O',
      parametri: 'Parametri',
      generatori: 'Generatori',
      diagnostica: 'Diagnostica',
      firmware: 'Firmware',
      registro: 'Registro interventi',
      titolo: 'Navigazione area tecnica',
    },
    parco: {
      titolo: 'Parco impianti',
      sottotitolo: 'Tutti gli impianti installati da {{installatore}}',
      impianti: 'Impianti',
      online: 'Online',
      offline: 'Irraggiungibili',
      degradati: 'Parziali',
      allarmi: 'Allarmi aperti',
      apri: 'Apri',
      inUso: 'In uso',
      ultimoContatto: 'Ultimo contatto',
      mai: 'mai',
      zone: '{{n}} zone',
      generatori: '{{n}} generatori',
      centralina: { emacomfort: 'Centralina Ema Comfort', terze_parti: 'Sistemi di terzi' },
      firmware: 'Firmware {{v}}',
    },
    canali: {
      titolo: 'Canali in tempo reale',
      sottotitolo: 'Valore grezzo e convertito di ogni canale dichiarato dalla centralina.',
      canale: 'Canale',
      assegnazione: 'Assegnazione',
      grezzo: 'Grezzo',
      convertito: 'Convertito',
      qualita: 'Qualità',
      modulo: 'Modulo',
      ingressi: 'Ingressi',
      uscite: 'Uscite',
      nonAssegnato: 'Non assegnato',
      confidenza: { alta: 'Confermato', media: 'Da confermare', bassa: 'Incerto' },
      qualitaValore: { ok: 'Valida', sonda_scollegata: 'Sonda scollegata', sospetto: 'Sospetta', mancante: 'Mancante' },
      stato: 'Stato',
      modulazione: 'Modulazione',
      forzato: 'Forzato fino alle {{ora}}',
      moduli: 'Moduli dichiarati',
      moduloStato: { ok: 'Presente', assente: 'Assente', guasto: 'Guasto' },
    },
    io: {
      titolo: 'Configurazione I/O',
      sottotitolo: 'Mappatura canale → zona o funzione, tipo sonda, taratura, tipo di carico per zona, test uscite.',
      assegnaA: 'Assegna a',
      zona: 'Zona',
      funzione: 'Funzione',
      nessuna: 'Nessuna',
      tipoSonda: 'Tipo sonda',
      offset: 'Offset',
      fattore: 'Fattore',
      salva: 'Salva canale',
      salvato: 'Canale {{canale}} salvato',
      tipoCarico: 'Tipo di carico per zona',
      tipoCaricoNota: 'Elettrovalvola, relè on/off e ventilconvettore si comportano in modo diverso: la centralina adatta il comando.',
      testUscita: 'Test uscita',
      forzaAttivo: 'Forza ATTIVO',
      forzaSpento: 'Forza SPENTO',
      timeout: 'Rientro automatico dopo',
      timeoutNota: 'Il timeout è imposto dalla centralina: se la connessione cade, l’uscita rientra comunque.',
      secondi: '{{n}} s',
      avviaForzatura: 'Avvia forzatura',
      annullaForzatura: 'Annulla forzatura',
      forzaturaAttiva: 'Forzatura attiva · rientro alle {{ora}}',
      confermaForzatura: 'Forzare l’uscita {{canale}} a {{stato}} per {{secondi}} secondi?',
      nota: 'Nota',
      sonda: { NTC_10K: 'NTC 10K', PT1000: 'PT1000', ANALOGICO: 'Analogico', DIGITALE: 'Digitale (connettore)' },
    },
    parametri: {
      titolo: 'Parametri di regolazione',
      sottotitolo: 'Tarature tecniche per impianto. Ogni modifica viene registrata con operatore, istante e valori prima/dopo.',
      avviso: 'I valori predefiniti sono un’assunzione in attesa dell’algoritmo di regolazione del committente.',
      salva: 'Salva parametri',
      salvato: 'Parametri salvati',
      nonValidi: 'Alcuni valori sono fuori dall’intervallo consentito.',
      gruppi: {
        curvaClimatica: 'Curva climatica',
        isteresi: 'Isteresi',
        deltaT: 'Delta T',
        circolatore: 'Circolatore',
        sanitario: 'Sanitario',
        cascata: 'Cascata generatori',
        comportamentoPin12: 'Comportamento attuatore generatore (pin 12)',
        protezioni: 'Protezioni',
        commutazioneStagionale: 'Commutazione stagionale',
        vmc: 'Ventilazione',
      },
      campi: {
        pendenza: 'Pendenza',
        temperaturaBase: 'Temperatura base',
        temperaturaEsternaProgetto: 'Esterna di progetto',
        mandataMin: 'Mandata minima',
        mandataMax: 'Mandata massima',
        zona: 'Isteresi zona',
        generatore: 'Isteresi generatore',
        tempoMinimoOnMin: 'Tempo minimo acceso',
        tempoMinimoOffMin: 'Tempo minimo spento',
        nominale: 'Delta T nominale',
        sogliaAllarme: 'Soglia di allarme',
        minutiPrimaDellAllarme: 'Minuti prima dell’allarme',
        modalita: 'Modalità',
        portataMinimaPct: 'Portata minima',
        setpoint: 'Setpoint ACS',
        isteresi: 'Isteresi ACS',
        prioritaSuRiscaldamento: 'Priorità sul riscaldamento',
        tettoPrioritaMin: 'Tetto priorità',
        antilegionellaTemperatura: 'Anti-legionella: temperatura',
        antilegionellaGiorno: 'Anti-legionella: giorno',
        antilegionellaOra: 'Anti-legionella: ora',
        ritardoSecondarioMin: 'Ritardo inserimento secondario',
        antigeloZona: 'Antigelo zona',
        antigeloEsterna: 'Antigelo esterna',
        sovratemperaturaDelta: 'Sovratemperatura (oltre la curva)',
        antibloccaggioGiorni: 'Anti-bloccaggio pompe',
        margineRugiada: 'Margine punto di rugiada',
        sogliaRiscaldamento: 'Sotto questa esterna: riscaldamento',
        sogliaRaffrescamento: 'Sopra questa esterna: raffrescamento',
        ritardoOre: 'Ritardo commutazione',
        sogliaUmidita: 'Soglia umidità',
      },
      unita: { gradi: '°C', minuti: 'min', ore: 'h', giorni: 'giorni', pct: '%', kelvinPerGrado: '°C/°C' },
      circolatoreModalita: { FISSO: 'Fisso', MODULANTE: 'Modulante' },
      pin12Nota: 'Scelto da un elenco descritto, mai da un numero nudo: fra due anni deve restare leggibile.',
    },
    generatori: {
      titolo: 'Generatori',
      sottotitolo: 'Dichiarazione dei generatori installati (1–4), canali associati e priorità di cascata.',
      aggiungi: 'Aggiungi generatore',
      rimuovi: 'Rimuovi',
      nome: 'Nome',
      tipo: 'Tipo',
      canaleMandata: 'Canale mandata',
      canaleRitorno: 'Canale ritorno',
      canaleComando: 'Canale comando',
      nessunComando: 'Nessuno',
      modulante: 'Modulante',
      su: 'Alza priorità',
      giu: 'Abbassa priorità',
      salva: 'Salva generatori',
      salvato: 'Generatori salvati',
      massimo: 'Massimo quattro generatori: termocamino, stufa a pellet, pompa di calore, caldaia a gas.',
      cascataNota: 'La priorità la imposta il tecnico, non è dedotta: un termocamino e una pompa di calore hanno logiche economiche opposte.',
      attivo: 'In funzione',
      inattivo: 'Fermo',
    },
    diagnostica: {
      titolo: 'Diagnostica',
      sottotitolo: 'Confronto mandata / ritorno / esterna ad alta risoluzione ed eventi della centralina.',
      ultime24h: 'Ultime 24 ore',
      eventi: 'Eventi recenti',
      nessunEvento: 'Nessun evento registrato.',
      esporta: 'Esporta CSV',
      tipo: {
        generatore: 'Generatore',
        sanitario: 'Sanitario',
        vmc: 'Ventilazione',
        modalita: 'Modalità',
        profilo: 'Profilo',
        allarme: 'Allarme',
        forzatura: 'Forzatura',
        protezione: 'Protezione',
        configurazione: 'Configurazione',
        connessione: 'Connessione',
        ota: 'Firmware',
      },
    },
    firmware: {
      titolo: 'Firmware / OTA',
      corrente: 'Versione installata',
      disponibile: 'Aggiornamento disponibile',
      nessuno: 'Nessun aggiornamento disponibile.',
      terzeParti: 'La centralina è di terze parti: il firmware non è gestito da Ema Comfort.',
      avvia: 'Avvia aggiornamento {{v}}',
      rollback: 'Torna alla versione {{v}}',
      testNonFirmato: 'Prova con immagine non firmata',
      testNonFirmatoNota: 'Dimostra che la centralina rifiuta un firmware privo di firma valida.',
      fase: {
        inattivo: 'Inattivo',
        pubblicazione: 'Pubblicazione',
        rollout: 'Rollout in corso',
        conferma: 'In attesa di conferma',
        completato: 'Completato',
        rifiutato: 'Rifiutato',
        rollback: 'Rollback in corso',
      },
      firmata: 'Immagine firmata',
      nonFirmata: 'Immagine NON firmata',
      rifiutatoNota: 'La centralina ha rifiutato l’immagine: firma assente o non valida.',
      confermaAvvio: 'Avviare l’aggiornamento alla versione {{v}} su questo impianto?',
    },
    registro: {
      titolo: 'Registro interventi',
      sottotitolo: 'In sola aggiunta: nessuna voce può essere modificata o cancellata.',
      operatore: 'Operatore',
      azione: 'Azione',
      oggetto: 'Oggetto',
      prima: 'Prima',
      dopo: 'Dopo',
      istante: 'Istante',
      vuoto: 'Nessun intervento registrato.',
      azioni: {
        accesso_area_tecnica: 'Accesso area tecnica',
        taratura_offset: 'Taratura: offset',
        taratura_fattore: 'Taratura: fattore',
        tipo_sonda: 'Tipo sonda',
        assegnazione_canale: 'Assegnazione canale',
        tipo_carico: 'Tipo di carico',
        parametro: 'Parametro',
        generatori: 'Generatori',
        forzatura: 'Forzatura uscita',
        rientro_forzatura: 'Rientro forzatura (timeout)',
        annulla_forzatura: 'Forzatura annullata',
        ota_avvio: 'Avvio aggiornamento',
        ota_rifiutato: 'Aggiornamento rifiutato',
        ota_rollback: 'Rollback firmware',
      },
    },
    funzione: {
      MANDATA_COLLETTORE: 'Mandata collettore',
      RITORNO_COLLETTORE: 'Ritorno collettore',
      ACCUMULO_SANITARIO: 'Accumulo sanitario',
      MANDATA_GENERATORE: 'Mandata generatore',
      RITORNO_GENERATORE: 'Ritorno generatore',
      PUFFER_ALTO: 'Puffer — alto',
      PUFFER_BASSO: 'Puffer — basso',
      TEMPERATURA_ESTERNA: 'Temperatura esterna',
      UMIDITA_INTERNA: 'Umidità interna',
      LUMINOSITA: 'Luminosità',
      VMC: 'Ventilazione (VMC)',
      LOGICA_GENERATORE: 'Logica generatore (pin 12)',
      CIRCOLATORE: 'Circolatore',
      VALVOLA_DEVIATRICE: 'Valvola deviatrice',
      COMANDO_GENERATORE: 'Comando generatore',
    },
    pin12: {
      1: 'ON/OFF generatore su domanda aggregata delle zone',
      2: 'PWM modulante circolatore, proporzionale alle zone aperte',
      3: 'PWM modulante generatore su errore di temperatura di mandata',
      4: 'Comando valvola deviatrice sanitario/riscaldamento',
      5: 'ON/OFF circolatore, senza modulazione',
      6: 'Consenso generatore esterno (contatto pulito)',
    },
  },
  comune: {
    conferma: 'Conferma',
    annulla: 'Annulla',
    salva: 'Salva',
    chiudi: 'Chiudi',
    indietro: 'Indietro',
    si: 'Sì',
    no: 'No',
    caricamento: 'Caricamento…',
    errore: 'Si è verificato un errore.',
    ok: 'OK',
    riprova: 'Riprova',
    apri: 'Apri',
    attivo: 'Attivo',
    spento: 'Spento',
    adesso: 'adesso',
    faMinuti: '{{n}} min fa',
    faOre: '{{n}} h fa',
    faGiorni: '{{n}} giorni fa',
    menu: 'Menu',
  },
  giorni: ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica'],
  giorniBrevi: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
  sorgenti: {
    ta: 'Centralina di terze parti con interfaccia documentata: letta e comandata in locale.',
    fv: 'Inverter fotovoltaico via cloud del produttore: produzione, batteria e consumi.',
    pdc: 'Pompa di calore via piattaforma comune: sola lettura finché il comando non è verificato per modello.',
    termostati: 'Termostati di marca via cloud del produttore: sola lettura.',
    emacomfort: 'Centralina Ema Comfort in LAN: lettura e comando.',
    tipo: { centralina: 'Centralina', fotovoltaico: 'Fotovoltaico', pompa_di_calore: 'Pompa di calore', termostati: 'Termostati' },
    comandabile: 'Lettura e comando',
    solaLettura: 'Sola lettura',
  },
  simulatore: {
    titolo: 'Simulatore',
    sottotitolo: 'Componi una configurazione d’impianto e apri l’app su quella, senza installarla da nessuna parte.',
    datiSimulati: 'Dati simulati',
    avvertenza:
      'Tutto ciò che si vede qui è simulato. Aprendo una configurazione, per questa sessione l’app mostra l’impianto composto qui sopra al posto di quello reale; si torna ai dati veri con “Esci dal simulatore”.',
    impianto: 'Impianto',
    centralina: 'Centralina',
    centralinaNota:
      'La centralina propria accetta comandi; un sistema di terzi è letto da un connettore e non ne accetta.',
    centralinaPropria: 'Ema Comfort',
    centralinaTerzi: 'Terze parti (sola lettura)',
    zone: 'Zone',
    zoneConteggio: '{{count}} zona',
    zoneConteggio_other: '{{count}} zone',
    generatori: 'Generatori',
    generatoriNota: 'Da uno a quattro, in cascata secondo l’ordine qui sotto.',
    servizi: 'Servizi',
    sanitario: 'Acqua calda sanitaria',
    vmc: 'Ventilazione (VMC)',
    sondaPuffer: 'Sonda sul puffer',
    sonde: 'Sonde d’impianto',
    sondeNota:
      'Una sonda assente non è un valore mancante: il dato che misura sparisce dall’interfaccia invece di restare vuoto.',
    sondeCentrale: 'Sonde di centrale termica',
    sondaEsterna: 'Sonda esterna',
    umidita: 'Sonda di umidità',
    fotovoltaico: 'Fotovoltaico',
    fvAssente: 'Assente',
    fvSenzaBatteria: 'Senza batteria',
    fvConBatteria: 'Con batteria',
    riepilogo: 'Riepilogo',
    canali: 'Canali',
    comandi: 'Comandi',
    comandiSi: 'Accettati',
    comandiNo: 'Rifiutati (sola lettura)',
    link: 'Link della configurazione',
    linkNota:
      'La configurazione sta tutta nell’indirizzo: questo link riapre esattamente questa configurazione, anche su un’altra macchina.',
    apri: 'Apri il pannello',
    copia: 'Copia il link',
    copiato: 'Link copiato',
    ripristina: 'Ripristina',
    esci: 'Esci dal simulatore',
    inCorso: 'Simulatore in corso',
    tornaAiDatiReali: 'Torna ai dati reali',
  },
  demo: {
    insegna: {
      etichetta: 'Demo',
      titolo: 'Impianto simulato',
      nota: 'Questa striscia è nostra: l’app è quella dentro lo schermo.',
      banco: 'Cambia impianto',
      /* Il banco di prova sta sul sito del prodotto: è lì che l’impianto si
         compone e si sceglie da quale area entrarci. Assoluto perché da qui
         si esce dal dominio dell’app. Si è spostato da
         www.puglieseweb.com/it/products/ema-comfort insieme al resto della
         pagina ([ADR-090]). Il vecchio percorso risponde ancora, ma con una
         pagina di meta-refresh (un redirect di configurazione Astro in una
         build statica non e' un 301 HTTP), e il meta refresh NON porta con se'
         il frammento: un bundle vecchio che segue il vecchio link atterra in
         cima alla pagina invece che sul banco — il vicolo cieco che questa
         insegna esiste per evitare. */
      bancoUrl: 'https://www.emacomfort.com/it/#demo',
    },
  },
  note: {
    'io-map.A3': 'Due bagni su un’unica sonda: da confermare con il committente (Q2b).',
    'io-map.A6': 'Non specificato nello schema: probabile riserva, da confermare.',
    'io-map.A7': 'Anche punto di espansione: un multiplexer su A7 aggiunge zone.',
    'io-map.A15': 'Uso presunto: ombreggiamento automatico (fase 3).',
    'ecobel.HP': 'Comando via cloud del produttore: da verificare per modello.',
  },
} as const;

export type Dizionario = typeof it;
